import React from "react";
import Icon from "../components/Icon";
import ContactForm from "../components/ContactForm";
import { brand, contact, contactPage, founders, agent } from "../data/siteData";
import "../styles/ContactUs.css";

export default function ContactUs() {
  return (
    <div className="tp-contact-page">
      {/* ---------------- Intro ---------------- */}
      {/* <section className="tp-section tp-section--tight tp-contact-page__intro">
        <div className="tp-container">
          <span className="tp-eyebrow">{contactPage.eyebrow}</span>
          <h1 className="tp-section-heading">{contactPage.heading}</h1>
          <p className="tp-section-sub">{contactPage.intro}</p>
        </div>
      </section> */}

      <section className="tp-handicrafts-hero tp-floral-bg2">
        <div className="tp-container">
          <span className="tp-eyebrow">{contactPage.eyebrow}</span>
          <h1 className="tp-section-heading">{contactPage.heading}</h1>
          <p className="tp-section-sub">{contactPage.intro}</p>
        </div>
      </section>

      {/* ---------------- Details + Map ---------------- */}
      <section className="tp-section tp-section--tight">
        <div className="tp-container tp-contact-page__grid">
          <div className="tp-contact-page__details">
            <div className="tp-contact-page__detail">
              <Icon name="pin" size={18} />
              <div>
                <span>Location</span>
                <p>{contact.location}</p>
              </div>
            </div>

            <div className="tp-contact-page__detail">
              <Icon name="mail" size={18} />
              <div>
                <span>Email</span>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </div>
            </div>

            <div className="tp-contact-page__detail">
              <Icon name="phone" size={18} />
              <div>
                <span>Call the Founders</span>
                {founders.map((f) => (
                  <p key={f.id}>
                    {f.name} —{" "}
                    <a href={`tel:${f.phone.replace(/\s+/g, "")}`}>{f.phone}</a>
                  </p>
                ))}
              </div>
            </div>

            <div className="tp-contact-page__detail">
              <Icon name="globe" size={18} />
              <div>
                <span>{agent.heading}</span>
                <p>{agent.name}</p>
                <p>{agent.altName}</p>
                <p>{agent.phones.join(" · ")}</p>
              </div>
            </div>

            <div className="tp-contact-page__detail">
              <Icon name="checkCircle" size={18} />
              <div>
                <span>Response Time</span>
                <p>{contact.responseTime}</p>
              </div>
            </div>

            <a
              href={contactPage.directionsUrl}
              target="_blank"
              rel="noreferrer"
              className="tp-btn tp-btn--outline tp-contact-page__directions"
            >
              Get Directions
              <Icon name="arrow" size={16} />
            </a>
          </div>

          <div className="tp-contact-page__map">
            <iframe
              title={`${brand.name} location map`}
              src={contactPage.mapEmbedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      {/* ---------------- Message form ---------------- */}
      <section className="tp-section tp-contact-page__form-section">
        <div className="tp-container tp-contact-page__form-wrap">
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
